import { render, staticRenderFns } from "./visitDialogs.vue?vue&type=template&id=78b2b81d&scoped=true&"
import script from "./visitDialogs.vue?vue&type=script&lang=js&"
export * from "./visitDialogs.vue?vue&type=script&lang=js&"
import style0 from "./visitDialogs.vue?vue&type=style&index=0&id=78b2b81d&prod&lang=less&scoped=true&"
import style1 from "./visitDialogs.vue?vue&type=style&index=1&id=78b2b81d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b2b81d",
  null
  
)

export default component.exports